export default [
    // ─── ADMINISTRATION ───────────────────────────────────────────────────────
    {
        header: 'Administration',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/users',
        name: 'Utilisateurs',
        slug: 'users',
        icon: 'fas fa-users',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/companies',
        name: 'Entreprises',
        slug: 'companies',
        icon: 'fas fa-building',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/programs',
        name: 'Programmes',
        slug: 'programs',
        icon: 'fas fa-city',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/prescribers',
        name: 'Prescripteurs',
        slug: 'prescribers',
        icon: 'fas fa-user-friends',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },

    // ─── CRM ──────────────────────────────────────────────────────────────────
    {
        header: 'CRM',
        roles: ['ROLE_ADMIN', 'ROLE_PRESCRIBER'],
    },
    {
        url: '/customers',
        name: 'Prospects / Clients',
        slug: 'customers',
        icon: 'fas fa-user',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/tracking-connections',
        name: 'Connexions',
        slug: 'tracking-connections',
        icon: 'fas fa-chart-line',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/denounces',
        name: 'Dénonces',
        slug: 'denounces',
        icon: 'BriefcaseIcon',
        roles: ['ROLE_ADMIN'],
        tagColor: 'success',
    },
    {
        url: '/prospects',
        name: 'Prospects',
        slug: 'prospects',
        icon: 'FileIcon',
        roles: ['ROLE_PRESCRIBER'],
    },
    {
        url: '/options',
        name: 'Options',
        slug: 'options',
        icon: 'SettingsIcon',
        roles: ['ROLE_ADMIN', 'ROLE_PRESCRIBER'],
    },
    {
        url: '/bookings',
        name: 'Réservations',
        slug: 'bookings',
        icon: 'BookmarkIcon',
        roles: ['ROLE_ADMIN', 'ROLE_PRESCRIBER'],
    },

    // ─── FINANCES ─────────────────────────────────────────────────────────────
    {
        header: 'Finances',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/notifications',
        name: 'Notifications',
        slug: 'notifications',
        icon: 'BellIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/invoices',
        name: 'Factures',
        slug: 'invoices',
        icon: 'DollarSignIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/payments',
        name: 'Paiement Accès',
        slug: 'payments',
        icon: 'CreditCardIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/contrats',
        name: 'Contrats',
        slug: 'contrats',
        icon: 'FileTextIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/articles',
        name: 'Articles',
        slug: 'articles',
        icon: 'ShoppingCartIcon',
        roles: ['ROLE_ADMIN'],
    },

    // ─── SYSTÈME ──────────────────────────────────────────────────────────────
    {
        header: 'Système',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/automatisation',
        name: 'Automatisation',
        slug: 'automatisation',
        icon: 'ActivityIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/subscriptions',
        name: 'Abonnement',
        slug: 'subscriptions',
        icon: 'CalendarIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/admin/trials',
        name: 'Video Onboarding',
        slug: 'admin-trials',
        icon: 'FilmIcon',
        i18n: 'Video Onboarding',
    },
];
